import { ReactElement, useCallback } from 'react';

import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';

import { pricingFormDataRequest } from './api';
import { PricingFormDataResponse } from './types';

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  PricingFormDataResponse,
  AxiosResultDefaultError
>();

export function usePricingLoader() {
  return useFetch();
}

/**
 * Carga los catálogos de precios (certificados, solicitudes, niveles
 * académicos) una sola vez para el tab. Cada sección guarda por su cuenta
 * contra su propio endpoint.
 */
export default function PricingLoader({
  children,
}: {
  children: ReactElement;
}) {
  const request = useCallback(async () => {
    return pricingFormDataRequest();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading insideCard />;
          } else if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
              />
            );
          } else if (data) {
            return children;
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
